<template>
  <div :class="containerClasses">
    <div :class="`pill pill--${size || 'large'} bg-${color || 'grey'}`">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrPill',
  props: ['size', 'color', 'classes', 'noMargin'],
  computed: {
    containerClasses: function() {
      let containerClasses = this.classes || '';

      if ((!this.classes || typeof this.classes !== 'string' || !this.classes.includes('offset')) && !this.noMargin) {
        containerClasses += ' bottom-offset3';
      }

      return containerClasses;
    }
  }
}
</script>